export function formatPrice(
  amount: number | null | undefined,
  currency: string = 'EUR',
  locale: string = 'it-IT',
): string {
  if (amount == null) return '—';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${currency} ${Math.round(amount)}`;
  }
}

export function formatDate(
  iso: string,
  locale: string = 'it-IT',
  opts: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' },
): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, opts).format(d);
}

export function formatDateRange(
  startIso: string,
  days: number | null | undefined,
  locale: string = 'it-IT',
): string {
  if (!startIso) return '';
  const start = new Date(startIso);
  if (Number.isNaN(start.getTime())) return startIso;
  if (!days || days <= 1) {
    return formatDate(startIso, locale);
  }
  const end = new Date(start);
  end.setDate(end.getDate() + days - 1);
  const fmt = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
  });
  return `${fmt.format(start)} – ${fmt.format(end)} ${start.getFullYear()}`;
}

export function pluralize(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

export function escapeHtml(str: string | null | undefined): string {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
